// extracted by mini-css-extract-plugin
module.exports = {"container":"navigation-step_container__RNxEz","mouseIconWrapper":"navigation-step_mouseIconWrapper__vJq3M","trackpadStepsContainer":"navigation-step_trackpadStepsContainer__PzrZ1"};